
import { defineComponent } from "vue";
import LayoutComponent from "./component.vue";
import StackContainer from "./stackContainer.vue";
import Handle from "./handle.vue";
import { useLayoutStore } from "@/stores/layoutStore";

export default defineComponent({
	setup() {
		const layoutStore = useLayoutStore();
		return { layoutStore };
	},
	name: "LayoutContainer",
	data() {
		return {
			uid: ""
		};
	},
	$refs: {
		$el: HTMLInputElement
	},
	beforeCreate() {
		this.uid = this.$uuid4();
	},
	mounted() {
		this.redrawHandles();
		window.addEventListener("resize", this.redrawHandles);
		const resize_ob = new ResizeObserver(() => {
			this.redrawHandles();
		});
		resize_ob.observe((this.$refs as any)[`${this.uid.toString()}`]);
	},
	watch: {
		panelLayout: {
			deep: true,
			handler() {
				this.redrawHandles();
			}
		}
	},
	props: {
		id: {
			type: Number,
			default: null
		},
		children: {
			type: Array as () => Array<LayoutType>,
			default: () => []
		},
		componentName: {
			type: String,
			default: ""
		},
		type: {
			type: String,
			default: "row"
		},
		component: {
			type: String,
			default: "LayoutComponent"
		},
		componentState: {
			type: Object as () => ComponentStateType,
			default: () => {
				return { flex: 1, color: "#fff" };
			}
		}
	},
	methods: {
		getComponentType(child: LayoutType) {
			if (child.component) {
				return "LayoutComponent";
			} else {
				if (child.type == "stacked") {
					return "StackContainer";
				} else {
					return "LayoutContainer";
				}
			}
		},
		redrawHandles() {
			this.$nextTick(() => {
				for (let i = 1; i < this.children.length; i++) {
					const COMP_EL: any =
						(this.$refs[
							"component_" + (this.children[i] as LayoutType).id
						] as Array<RefType>) &&
						(this.$refs[
							"component_" + (this.children[i] as LayoutType).id
						] as Array<RefType>);
					const HANDLE_EL: any =
						(this.$refs[
							"handle_" + (this.children[i] as LayoutType).id
						] as Array<RefType>) &&
						(this.$refs[
							"handle_" + (this.children[i] as LayoutType).id
						] as Array<RefType>);

					if (
						COMP_EL == null ||
						HANDLE_EL == null ||
						COMP_EL.length == 0 ||
						HANDLE_EL.length == 0
					)
						return;
					const { width, left, top }: { width: number; left: number; top: number } =
						COMP_EL[0].$el.getBoundingClientRect();
					const EL_BOUNDS: BoundType = this.$el.getBoundingClientRect();
					if (this.type == "row") {
						HANDLE_EL[0].$el.style.left = left - EL_BOUNDS.left + "px";
					}
					if (this.type == "column") {
						HANDLE_EL[0].$el.style.top = top - EL_BOUNDS.top + "px";
						HANDLE_EL[0].$el.style.width = width + "px";
						HANDLE_EL[0].$el.style.left = 0 + "px";
					}
				}
			});
		}
	},
	computed: {
		horizontalChildren() {
			const getAmountOfHorizontalChildren: any = (obj: any, count: number) => {
				if (obj.children && obj.children.length > 0) {
					for (let i = 0; i < obj.children.length; i++) {
						if (obj.children[i].type == "row") {
							count += obj.children[i].children.length;
							// count += 1;
							count += getAmountOfHorizontalChildren(obj.children[i], count);
						} else if (obj.children[i].type == "column") {
							count += 1;
						} else {
							//     console.log(obj.children[i].type);
							//    count += 1;
						}
					}
					return count;
				} else {
					return 0;
				}
			};
			return getAmountOfHorizontalChildren({ type: this.type, children: this.children }, 0);
		},
		verticalChildren() {
			const getAmountOfVerticalChildren: any = (obj: any, count: number) => {
				if (obj.children && obj.children.length > 0) {
					for (let i = 0; i < obj.children.length; i++) {
						if (obj.children[i].type == "column") {
							count += getAmountOfVerticalChildren(obj.children[i], 0);
						}
						if (obj.children[i].type == "row") {
							return 0;
						}
						if (obj.children[i].type == "stacked") {
							count += 1;
						}
					}
					return count;
				} else {
					return count;
				}
			};
			return getAmountOfVerticalChildren({ type: this.type, children: this.children }, 0);
		},
		minWidth() {
			return 150;
		},
		panelLayout() {
			return this.layoutStore.panelLayout;
		},
		handleIds() {
			const IDS = this.children.map((item: LayoutType) => item.id);
			IDS.shift();
			return IDS;
		},
		allIds() {
			const IDS = this.children.map((item: LayoutType) => item.id);
			return IDS;
		},
		stacked() {
			return this.type == "stacked";
		}
	},
	components: {
		LayoutComponent,
		StackContainer,
		Handle
	}
});
